import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import { TriStateCheckbox } from 'primereact/tristatecheckbox';

const IdentifierListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [identifiers, setIdentifiers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [identifierType, setIdentifierType] = useState({});
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
    filters: {
      active: { value: null, matchMode: 'equals' },
      type: { value: null, matchMode: 'contains' },
      identifier: { value: null, matchMode: 'contains' },
      name: { value: null, matchMode: 'contains' },
    }
  });

  const buildQueryString = (params) => {
    const sort = params.sortField === 'id' ? 'identifier' : params.sortField;
    const direction = params.sortOrder === 1 ? 'asc' : 'desc';
    let query = `?sort=${sort}&direction=${direction}`;
    if (params.filters) {
      Object.keys(params.filters).forEach(key => {
        const filter = params.filters[key];
        if (filter.value !== null && filter.value !== undefined && filter.value !== '') {
          query += `&search[${key}][operator]==&search[${key}][value]=${encodeURIComponent(filter.value)}`;
        }
      });
    }
    query += `&item_per_page=${rows}`;
    return query;
  };
  // let loadLazyTimeout = null;
  const loadLazyTimeout = useRef(null);
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout.current) {
      clearTimeout(loadLazyTimeout.current);
    }
    loadLazyTimeout.current = setTimeout(() => {
      const query = buildQueryString(lazyParams);
    
    console.log("Kimenő query:", query);
      // let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/identifier' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setIdentifiers(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
      apiCall('get', '/api/v2/dictionary/identifier-type')
        .then(response => {
          const map = {};
          (response.data.data || []).forEach(item => {
            map[item.key] = item.value;
          })
          setIdentifierType(map);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_identifier_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'identifier') {
                      history.push('/settings/identifier/update/' + rowData.identifier)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_identifier_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/identifier/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderIdentifierList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderIdentifierList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={identifiers} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="active" header={t('columnActive')} sortable filter dataType="boolean" className={"p-text-left"} filterElement={(options) => (
          <TriStateCheckbox
            value={options.value}
            onChange={(e) => options.filterApplyCallback(e.value)}
          />
        )} body={(rowData) => {
          return (
            <span id={rowData.id}>
            {rowData.active === true ? (
              <i className={"pi pi-check text-success"}></i>
            ) : (
              <i className={"pi pi-times text-danger"}></i>
            )}
            </span>
          )
        }}></Column>

        {/* <Column field="type" header={t('columnType')} sortable filter className='p-text-center' body={(rowData) => {
          return (
            <span id={rowData.id + 'type'}>{identifierType ? identifierType[rowData.type] : ''}</span>
          )
        }}></Column> */}

        <Column field="type" header={t('columnType')} sortable filter filterElement={(options) => (
          <Dropdown
            value={options.value}
            options={Object.entries(identifierType).map(([key, value]) => ({
              label: value,
              value: key
            }))}
            placeholder={t('selectPlaceholder')}
            showClear
            appendTo={document.body}
            onChange={(e) => options.filterApplyCallback(e.value)}
            style={{ width: '100%' }}
          />
        )} body={(rowData) => (
          <span id={rowData.id + 'type'}>
            {identifierType?.[rowData.type] ?? rowData.type ?? ''}
          </span>
        )}></Column>

        <Column field="identifier" header={t('columnIdentifier')} bodyClassName="col-body-font-bold" sortable filter></Column>

        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>

        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(IdentifierListComponent);
